export default __webpack_public_path__ + "static/media/female_open_short.3a4eb7fe.png";